/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type UpdateHexMagicMutationVariables = Types.Exact<{
  hexMagic: Types.Scalars["Boolean"]["input"];
}>;

export type UpdateHexMagicMutation = {
  readonly __typename: "Mutation";
  readonly updateHexMagic: {
    readonly __typename: "User";
    readonly id: c.UserId;
    readonly hexMagic: boolean;
  };
};

export const UpdateHexMagicDocument = /*#__PURE__*/ gql`
  mutation UpdateHexMagic($hexMagic: Boolean!) {
    updateHexMagic(enabled: $hexMagic) {
      id
      hexMagic
    }
  }
`;
export type UpdateHexMagicMutationFn = Apollo.MutationFunction<
  UpdateHexMagicMutation,
  UpdateHexMagicMutationVariables
>;

/**
 * __useUpdateHexMagicMutation__
 *
 * To run a mutation, you first call `useUpdateHexMagicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHexMagicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHexMagicMutation, { data, loading, error }] = useUpdateHexMagicMutation({
 *   variables: {
 *      hexMagic: // value for 'hexMagic'
 *   },
 * });
 */
export function useUpdateHexMagicMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateHexMagicMutation,
    UpdateHexMagicMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateHexMagicMutation,
    UpdateHexMagicMutationVariables
  >(UpdateHexMagicDocument, options);
}
export type UpdateHexMagicMutationHookResult = ReturnType<
  typeof useUpdateHexMagicMutation
>;
export type UpdateHexMagicMutationResult =
  Apollo.MutationResult<UpdateHexMagicMutation>;
export type UpdateHexMagicMutationOptions = Apollo.BaseMutationOptions<
  UpdateHexMagicMutation,
  UpdateHexMagicMutationVariables
>;
